import React from 'react';
import { useTerminologia } from '../../hooks/useTerminologia';

const formatARS = (value) =>
    value != null && value !== 0
        ? new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 2 }).format(value)
        : '';

const formatPeriodo = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' });
};

const PdfExpensas = ({ expensas = [], periodo }) => {
    const t = useTerminologia();
    const totales = expensas.reduce(
        (acc, row) => ({
            expensaOrdinaria: acc.expensaOrdinaria + (row.expensaOrdinaria || 0),
            expensaExtraordinaria: acc.expensaExtraordinaria + (row.expensaExtraordinaria || 0),
            cargoPeriodoImporte: acc.cargoPeriodoImporte + (row.cargoPeriodoImporte || 0),
            intereses: acc.intereses + (row.intereses || 0),
            totalProntoPago: acc.totalProntoPago + (row.totalProntoPago || 0),
            totalSinProntoPago: acc.totalSinProntoPago + (row.totalSinProntoPago || 0),
        }),
        { expensaOrdinaria: 0, expensaExtraordinaria: 0, cargoPeriodoImporte: 0, intereses: 0, totalProntoPago: 0, totalSinProntoPago: 0 }
    );

    return (
        <>
            <div className="pdf-section-title">
                DISTRIBUCIÓN DE GASTOS Y SALDOS A PAGAR — {formatPeriodo(periodo)?.toUpperCase()}
            </div>

            <table className="pdf-data-table pdf-data-table-sm">
                <thead>
                    <tr>
                        <th style={{ width: '50px' }}>{t.UF}</th>
                        <th>Propietario</th>
                        <th className="pdf-col-number" style={{ width: '75px' }}>Exp. Ordinaria</th>
                        <th className="pdf-col-number" style={{ width: '75px' }}>Exp. Extraordinaria</th>
                        <th className="pdf-col-number" style={{ width: '65px' }}>Cargo Período</th>
                        <th className="pdf-col-number" style={{ width: '60px' }}>Intereses</th>
                        <th className="pdf-col-number" style={{ width: '75px' }}>Total P.P.</th>
                        <th className="pdf-col-number" style={{ width: '75px' }}>Total S.P.P.</th>
                    </tr>
                </thead>
                <tbody>
                    {expensas.length === 0 ? (
                        <tr>
                            <td colSpan={8} style={{ textAlign: 'center', fontStyle: 'italic' }}>
                                Sin datos de expensas
                            </td>
                        </tr>
                    ) : (
                        expensas.map((row, i) => (
                            <tr key={i}>
                                <td>{row.unidadFuncionalMostrar}</td>
                                <td>{row.propietario}</td>
                                <td className="pdf-col-number">{formatARS(row.expensaOrdinaria)}</td>
                                <td className="pdf-col-number">{formatARS(row.expensaExtraordinaria)}</td>
                                <td className="pdf-col-number">{formatARS(row.cargoPeriodoImporte)}</td>
                                <td className="pdf-col-number">{formatARS(row.intereses)}</td>
                                <td className="pdf-col-number">{formatARS(row.totalProntoPago)}</td>
                                <td className="pdf-col-number">{formatARS(row.totalSinProntoPago)}</td>
                            </tr>
                        ))
                    )}
                    {expensas.length > 0 && (
                        <tr className="pdf-row-total">
                            <td colSpan={2}>Totales</td>
                            <td className="pdf-col-number">{formatARS(totales.expensaOrdinaria)}</td>
                            <td className="pdf-col-number">{formatARS(totales.expensaExtraordinaria)}</td>
                            <td className="pdf-col-number">{formatARS(totales.cargoPeriodoImporte)}</td>
                            <td className="pdf-col-number">{formatARS(totales.intereses)}</td>
                            <td className="pdf-col-number">{formatARS(totales.totalProntoPago)}</td>
                            <td className="pdf-col-number">{formatARS(totales.totalSinProntoPago)}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
};

export default PdfExpensas;
